import React from 'react';
import { CommentValidationProvider } from '@contexts/comment-validation-context';

/**
 * Higher Order Component that wraps any component with CommentValidationProvider
 * This makes it easy to migrate existing detail pages to use the new comment validation system
 * 
 * Usage:
 * 1. Import this HOC: import WithCommentValidation from '@components/shared/with-comment-validation';
 * 2. Import the migration hook: import useCommentValidationMigration from '@hooks/useCommentValidationMigration';
 * 3. In your component, use: const { requireComment } = useCommentValidationMigration();
 * 4. Replace: if (!window.wasCommented) { alert("Debe ingresar un comentario"); return; }
 *    With: if (!requireComment()) { return; }
 * 5. Remove: window.wasCommented = false; from useEffect
 * 6. Export your component wrapped: export default WithCommentValidation(YourComponent);
 */
const WithCommentValidation = (WrappedComponent) => {
  const ComponentWithCommentValidation = (props) => {
    return (
      <CommentValidationProvider>
        <WrappedComponent {...props} />
      </CommentValidationProvider>
    );
  };

  // Set display name for debugging
  ComponentWithCommentValidation.displayName = `WithCommentValidation(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;

  return ComponentWithCommentValidation;
};

export default WithCommentValidation; 